/*
 * 常量文件
 * Copyright (c) 2018. supOS
 */
// import { pot, valve } from './sysTemp';
import commonMessage from 'root/common/messages';

export const IconName = {
  LabelCtrl: 'icon_label_form',
  CalendarCtrl: 'icon_times_form',
  InputCtrl: 'icon_input_form',
  SelectCtrl: 'icon_select_form',
  CascaderCtrl: 'icon_select_form',
  ReporterCtrl: 'icon_report_controls',
  RadioCtrl: 'icon_radio_form',
  CheckboxCtrl: 'icon_check_form',
  DatePickerCtrl: 'icon_times_form',
  TreeCtrl: 'icon_tree_form',
  ButtonCtrl: 'icon_btn_form',
  SingleList: 'icon_input_form',
  TableCtrl: 'icon_form_form',
  TodoCtrl: 'icon_form_form',
  // ProcessBtnCtrl: 'icon_btn_form',
  // ProcessLogCtrl: 'icon_input_form',
  Webview: 'icon_form_form',
  Circle: 'icon_circle_graphics',
  Rect: 'icon_rectangular_graphics',
  Oval: 'icon_ellipse_graphics',
  RoundRect: 'icon_r_rectangular_graphics',
  Polygon: 'icon_polygon_graphics',
  Arc: 'icon_arc_graphics',
  Star: 'icon_star_graphics',
  Triangle: 'icon_triangle_graphics',
  Hexagon: 'icon_custom',
  lineArrow: 'icon_line',
  RealAlarm: 'icon_realtimealarm_contorls',
  HistoryAlarm: 'icon_historicalalarm_contorls',
  LiveStreaming: 'icon_video_controls',
  VideoCtrl: 'icon_video_controls',
  VideoWallCtrl: 'icon_video_wall',
  NewLiveStreaming: 'icon_video_controls',
  TrendChart: 'icon_trend_contorls',
  LineChart: 'icon_polyline_chart',
  SplineChart: 'icon_graph_chart',
  Column: 'icon_histogram_chart',
  Dashboard: 'icon_dashboard_chart',
  Gauge: 'icon_t_dashboard_chart',
  Scatter: 'icon_scatter_chart',
  Bubble: 'icon_bubble_chart',
  Area: 'icon_area_chart',
  Pie: 'icon_piechart_chart',
  AnnularChart: 'icon_annular_chart',
  SpcChart: 'icon_spc',
  BarChart: 'icon_histogram_barchart',
  Ellipse: 'icon_area_chart',
  Group: 'icon_area_chart',
  Funnel: 'icon_funnel_chart',
  SpiderChart: 'icon_radar_chart',
  HeatMap: 'icon_map_chart',
  ArithmeticIN: 'in',
  ArithmeticOUT: 'out',
  ArithmeticADD: 'add',
  ArithmeticAVE: 'ave',
  ArithmeticDIV: 'div',
  ArithmeticECP: 'ecp',
  ArithmeticGT: 'gt',
  ArithmeticSEL: 'sel',
  ArithmeticPFC: 'pfc',
  ArithmeticMRT: 'mrt',
  ArithmeticFLC: 'flc',
  ArithmeticLT: 'lt',
  image: 'icon_pic_graphics',
  UploadImg: 'icon_pic_graphics',
  UploadCtrl: 'btn_upload',
  TabsCtrl: 'icon_text_graphics',
  Edge: 'icon_brokenline_graphics',
  Pipe: 'icon_pipe_graphics',
  Text: 'icon_text_graphics',
  dataLink: 'icon_linterlinkade_graphics_1',
  Shape: 'icon_pen_graphice_1',
  LineCtrl: 'btn_minus_form',
  HiddenFieldCtrl: 'file-hidden',
  StartWorkProcess: 'btn_startgzl',
  StartWorkProcessBtn: 'icon_btn_form',
  BreadcrumbCtrl: 'icon_mianbaoxie',
  SearchCtrl: 'icon_search',
  CarouselCtrl: 'icon_lunbo',
  CustomTemp: 'mokuai', // 自定义模板库icon
  CustomComp: 'icon_kebianc',
  IntervalCtrl: 'icon_setinterval',
  Grid: 'icon_rectangular_graphics',
  ZoneCtrl: 'icon_rectangular_graphics',
  HTContainer: 'icon_rectangular_graphics',
  Demo: 'icon_rectangular_graphics'
};

export const codeMessage = {
  200: getServiceMessage(200),
  201: getServiceMessage(201),
  202: getServiceMessage(202),
  204: getServiceMessage(204),
  400: getServiceMessage(400),
  401: getServiceMessage(401),
  403: getServiceMessage(403),
  404: getServiceMessage(404),
  406: getServiceMessage(406),
  410: getServiceMessage(410),
  422: getServiceMessage(422),
  500: getServiceMessage(500),
  502: getServiceMessage(502),
  503: getServiceMessage(503),
  504: getServiceMessage(504)
};

export function tabsName(intl) {
  return {
    Controller: intl.formatMessage(commonMessage.chooseCompoent),
    Address: intl.formatMessage(commonMessage.URLparameter),
    Filter: intl.formatMessage(commonMessage.filterMachine),
    Camera: intl.formatMessage(commonMessage.StreamSource),
    instance: intl.formatMessage(commonMessage.objectInstance),
    template: intl.formatMessage(commonMessage.objectTemplate),
    feature: intl.formatMessage(commonMessage.featureCollection),
    network: intl.formatMessage(commonMessage.network),
    property: intl.formatMessage(commonMessage.attribute)
  };
}

export function categories(intl) {
  return [
    {
      name: intl.formatMessage(commonMessage.ButtonCtrl),
      path: '2',
      count: 23
    },
    {
      name: intl.formatMessage(commonMessage.pump),
      path: '3',
      count: 45
    },
    {
      name: intl.formatMessage(commonMessage.sensor),
      path: '4',
      count: 12
    },
    {
      name: intl.formatMessage(commonMessage.transfer),
      path: '5',
      count: 12
    },
    {
      name: intl.formatMessage(commonMessage.electric),
      path: '6',
      count: 27
    },
    {
      name: intl.formatMessage(commonMessage.valve),
      path: '7',
      count: 85
    },
    {
      name: intl.formatMessage(commonMessage.fan),
      path: '8',
      count: 12
    },
    {
      name: intl.formatMessage(commonMessage.symbol),
      path: '9',
      count: 42
    },
    {
      name: intl.formatMessage(commonMessage.pipe),
      path: '10',
      count: 12
    },
    {
      name: intl.formatMessage(commonMessage.jar),
      path: '11',
      count: 40
    },
    {
      name: intl.formatMessage(commonMessage.filter),
      path: '12',
      count: 6
    },
    {
      name: intl.formatMessage(commonMessage.heatexchanger),
      path: '13',
      count: 12
    },
    {
      name: intl.formatMessage(commonMessage.treater),
      path: '14',
      count: 22
    }, {
      name: intl.formatMessage(commonMessage.condensing),
      path: '15',
      count: 12
    }, {
      name: intl.formatMessage(commonMessage.flowmeter),
      path: '16',
      count: 12
    }, {
      name: intl.formatMessage(commonMessage.other),
      path: '17',
      count: 64
    }, {
      name: intl.formatMessage(commonMessage.tower),
      path: '18',
      count: 3
    }
  ];
}

export const unitList = [
  '%',
  '‰',
  '℃',
  'F',
  's',
  'M',
  'min',
  'hour',
  'bar',
  'mmH20',
  'mmHg',
  'Pa',
  'kPa',
  'MPa',
  'kgf/cm2',
  't/s',
  't/min',
  't/h',
  'L/s',
  'L/min ',
  'L/h',
  'kg/s',
  'kg/min',
  'kg/h',
  'km/h',
  'km/s',
  'm/s',
  'm3/s',
  'm3/min',
  'm3/h',
  'Nm3/h',
  'KW·h',
  'MW',
  'W',
  'kW',
  'WH',
  'MHz',
  'kHz',
  'Hz',
  'Ntu',
  'μg/L',
  'm3',
  'μg/Kg',
  'L',
  'Ml',
  't',
  'g',
  'mV',
  'mA',
  'rpm',
  'atm',
  'kg',
  'km',
  'm',
  'cm',
  'mm',
  'μm',
  'mbar',
  'N·m',
  'μs/cm',
  'A ',
  'kA',
  'VA',
  'V ',
  'kV',
  'r/min',
  'PH',
  'ppm',
  'Nm3',
  'KpaG',
  'mg',
  'Var',
  'VarH',
  '步',
  '米',
  '厘米',
  '毫米',
  '微米',
  '公斤',
  '克',
  '毫克',
  '吨',
  '方/小时',
  '升/小时',
  '升/秒',
  '吨/小时',
  '千克/秒',
  '立方米',
  '升',
  '毫升',
  '小时',
  '分',
  '秒',
  '毫秒',
  '伏特',
  '安培',
  '赫兹',
  '瓦特',
  '乏尔',
  '伏安'
];

export const fontSizeItems = ['8', '9', '10', '11', '12', '13', '14', '16', '18', '20', '22', '24', '26', '28', '36', '48', '72'];
export const fontFamilyItems = [
  'Arial',
  'Arial Black',
  'Calibri',
  'Cambria ',
  'Century ',
  'Courier New',
  'Comic Sans MS',
  'Garamond',
  'Georgia',
  'Malgun Gothic ',
  'Mangal ',
  ' Meiryo',
  'MS Gothic',
  'MS Mincho',
  'MS PGothic',
  'MS PMincho',
  'Roboto',
  'Tahoma',
  'Times',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
  'Wingdings'
];
export function allGroup(intl) {
  return {
    chart: [
      {
        id: 'LineChart',
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.LineChart)
      },
      {
        id: 'SplineChart',
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.SplineChart)
      },
      {
        id: 'Column',
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Column)
      },
      {
        id: 'Area',
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Area)
      },
      {
        id: 'Dashboard',
        defaultWidth: 250,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Dashboard)
      },
      {
        id: 'Gauge',
        defaultWidth: 250,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Gauge)
      },
      {
        id: 'Bubble',
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Bubble)
      },
      {
        id: 'Scatter',
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Scatter)
      },
      {
        id: 'Pie',
        defaultWidth: 250,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Pie)
      },
      {
        id: 'Funnel',
        defaultWidth: 250,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.Funnel)
      },
      {
        id: 'SpiderChart',
        defaultWidth: 300,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.SpiderChart)
      },
      {
        id: 'AnnularChart',
        defaultWidth: 300,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.AnnularChart)
      },
      {
        id: 'SpcChart',
        defaultWidth: 450,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.SpcChart)
      },
      {
        id: 'BarChart',
        defaultWidth: 300,
        defaultHeight: 250,
        displayName: intl.formatMessage(commonMessage.BarChart)
      }
      // {
      //   id: 'HeatMap',
      //   displayName: '热力图'
      // }
    ],
    form: [
      {
        id: 'LineCtrl',
        displayName: intl.formatMessage(commonMessage.LineCtrl),
        defaultWidth: 168,
        defaultHeight: 32,
        ctrlType: 'form'
      },
      {
        id: 'LabelCtrl',
        displayName: intl.formatMessage(commonMessage.LabelCtrl),
        defaultWidth: 168,
        defaultHeight: 32,
        ctrlType: 'form'
      },
      {
        id: 'HiddenFieldCtrl',
        displayName: intl.formatMessage(commonMessage.HiddenFieldCtrl),
        defaultWidth: 56,
        defaultHeight: 56,
        ctrlType: 'form'
      },
      {
        id: 'InputCtrl',
        displayName: intl.formatMessage(commonMessage.InputCtrl),
        defaultWidth: 348,
        defaultHeight: 32,
        ctrlType: 'form'
      },
      {
        id: 'SelectCtrl',
        displayName: intl.formatMessage(commonMessage.SelectCtrl),
        defaultWidth: 348,
        defaultHeight: 32,
        ctrlType: 'form'
      },
      {
        id: 'CascaderCtrl',
        displayName: intl.formatMessage(commonMessage.CascaderCtrl),
        defaultWidth: 348,
        defaultHeight: 32,
        ctrlType: 'form'
      },
      {
        id: 'RadioCtrl',
        displayName: intl.formatMessage(commonMessage.RadioCtrl),
        defaultWidth: 348,
        defaultHeight: 32,
        ctrlType: 'form'
      },
      {
        id: 'CheckboxCtrl',
        displayName: intl.formatMessage(commonMessage.CheckboxCtrl),
        defaultWidth: 348,
        defaultHeight: 32,
        ctrlType: 'form'
      },
      {
        id: 'DatePickerCtrl',
        displayName: intl.formatMessage(commonMessage.DatePickerCtrl),
        defaultWidth: 348,
        defaultHeight: 32,
        ctrlType: 'form'
      },
      {
        id: 'ButtonCtrl',
        displayName: intl.formatMessage(commonMessage.ButtonCtrl),
        defaultWidth: 120,
        defaultHeight: 36,
        ctrlType: 'form'
      },
      {
        id: 'TreeCtrl',
        displayName: intl.formatMessage(commonMessage.TreeCtrl),
        defaultWidth: 200,
        defaultHeight: 290,
        ctrlType: 'form'
      },
      {
        id: 'SingleList',
        displayName: intl.formatMessage(commonMessage.SingleList),
        defaultWidth: 180,
        defaultHeight: 333,
        ctrlType: 'form'
      },
      {
        id: 'TableCtrl',
        displayName: intl.formatMessage(commonMessage.TableCtrl),
        defaultWidth: 586,
        defaultHeight: 300,
        ctrlType: 'form'
      },
      {
        id: 'UploadImg',
        displayName: intl.formatMessage(commonMessage.UploadImg),
        defaultWidth: 200,
        defaultHeight: 200,
        ctrlType: 'form'
      },
      {
        id: 'TabsCtrl',
        displayName: intl.formatMessage(commonMessage.TabsCtrl),
        defaultWidth: 300,
        defaultHeight: 300,
        ctrlType: 'form'
      },
      {
        id: 'UploadCtrl',
        displayName: intl.formatMessage(commonMessage.UploadCtrl),
        defaultWidth: 120,
        defaultHeight: 120,
        ctrlType: 'form'
      },
      {
        id: 'BreadcrumbCtrl',
        displayName: intl.formatMessage(commonMessage.crumbs),
        defaultWidth: 400,
        defaultHeight: 100,
        ctrlType: 'form'
      },
      {
        id: 'SearchCtrl',
        displayName: intl.formatMessage(commonMessage.search),
        defaultWidth: 348,
        defaultHeight: 32,
        ctrlType: 'form'
      }
    ],
    graph: [
      {
        id: 'Shape',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Shape),
        layoutType: 'workFlow'
      },
      {
        id: 'Circle',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Circle),
        layoutType: 'both'
      },
      {
        id: 'Rect',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Rect),
        layoutType: 'both'
      },
      {
        id: 'Oval',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Oval),
        layoutType: 'both'
      },
      {
        id: 'RoundRect',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.RoundRect),
        layoutType: 'both'
      },
      {
        id: 'Polygon',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Polygon),
        layoutType: 'both'
      },
      {
        id: 'Hexagon',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Hexagon),
        layoutType: 'both'
      },
      {
        id: 'Triangle',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Triangle),
        layoutType: 'both'
      },
      {
        id: 'Star',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Star),
        layoutType: 'both'
      },
      {
        id: 'Arc',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Arc),
        layoutType: 'both'
      },
      {
        id: 'Text',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Text),
        layoutType: 'workFlow'
      },
      {
        id: 'Edge',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Edge),
        layoutType: 'workFlow'
      },
      {
        id: 'image',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.image),
        layoutType: 'both'
      },
      {
        id: 'Pipe',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.Pipe),
        layoutType: 'workflow'
      },
      {
        id: 'dataLink',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.dataLink),
        layoutType: 'workflow'
      },
      {
        id: 'lineArrow',
        isCanvas: true,
        displayName: intl.formatMessage(commonMessage.lineArrow),
        layoutType: 'workflow'
      }
    ],
    control: [
      {
        id: 'RealAlarm',
        defaultWidth: 800,
        defaultHeight: 500,
        displayName: intl.formatMessage(commonMessage.RealAlarm)
      },
      {
        id: 'HistoryAlarm',
        defaultWidth: 800,
        defaultHeight: 500,
        displayName: intl.formatMessage(commonMessage.HistoryAlarm)
      },
      // TODO 删除对应文件！！！
      // {
      //   id: 'LiveStreaming',
      //   defaultWidth: 400,
      //   defaultHeight: 300,
      //   displayName: intl.formatMessage(commonMessage.LiveStreaming)
      // },
      {
        id: 'VideoCtrl',
        defaultWidth: 400,
        defaultHeight: 300,
        displayName: intl.formatMessage(commonMessage.LiveStreaming)
      },
      {
        id: 'VideoWallCtrl',
        defaultWidth: 400,
        defaultHeight: 300,
        displayName: intl.formatMessage(commonMessage.videoWall)
      },
      {
        id: 'IntervalCtrl',
        displayName: intl.formatMessage(commonMessage.IntervalCtrl),
        defaultWidth: 32,
        defaultHeight: 32
      },
      // TODO 删除对应文件！！！！
      // {
      //   id: 'NewLiveStreaming',
      //   defaultWidth: 400,
      //   defaultHeight: 300,
      //   displayName: intl.formatMessage(commonMessage.NewLiveStreaming)
      // },
      {
        id: 'TrendChart',
        defaultWidth: 800,
        defaultHeight: 500,
        displayName: intl.formatMessage(commonMessage.TrendChart)
      },
      {
        id: 'TodoCtrl',
        defaultWidth: 350,
        defaultHeight: 180,
        displayName: intl.formatMessage(commonMessage.TodoCtrl)
      },
      {
        id: 'ReporterCtrl',
        defaultWidth: 600,
        defaultHeight: 400,
        displayName: intl.formatMessage(commonMessage.ReporterCtrl),
        ctrlType: 'form'
      },
      {
        id: 'Webview',
        defaultWidth: 640,
        defaultHeight: 480,
        displayName: intl.formatMessage(commonMessage.Webview),
        ctrlType: 'form'
      },
      {
        id: 'CarouselCtrl',
        displayName: intl.formatMessage(commonMessage.carousel),
        defaultWidth: 450,
        defaultHeight: 250,
        ctrlType: 'form'
      },
      // {
      //   id: 'ProcessLogCtrl',
      //   defaultWidth: 390,
      //   defaultHeight: 390,
      //   displayName: intl.formatMessage(commonMessage.ProcessLogCtrl)
      // },
      {
        id: 'StartWorkProcess',
        defaultWidth: 320,
        defaultHeight: 320,
        displayName: intl.formatMessage(commonMessage.WorkProcessList)
      },
      {
        id: 'StartWorkProcessBtn',
        defaultWidth: 150,
        defaultHeight: 50,
        displayName: intl.formatMessage(commonMessage.StartWorkProcessBtn)
      },
      // {
      //   id: 'ProcessBtnCtrl',
      //   defaultWidth: 120,
      //   defaultHeight: 36,
      //   displayName: intl.formatMessage(commonMessage.FlowButton)
      // },
      {
        id: 'CalendarCtrl',
        defaultWidth: 520,
        defaultHeight: 690,
        displayName: intl.formatMessage(commonMessage.calendar)
      },
      {
        id: 'CustomComp',
        defaultWidth: 120,
        defaultHeight: 120,
        displayName: intl.formatMessage(commonMessage.programme)
      }
    ]
    // temp: [
    //   {
    //     id: 'Pot',
    //     isCanvas: true,
    //     displayName: '罐子',
    //     layoutType: 'workflow'
    //   },
    //   {
    //     id: 'Valve',
    //     isCanvas: true,
    //     displayName: '阀门',
    //     layoutType: 'workflow'
    //   }
    // ]
  };
}

// TODO: 统一处理国际化
function getServiceMessage(code) {
  return JSON.parse(localStorage.getItem('language_message')) ? JSON.parse(localStorage.getItem('language_message'))[`common.service${code}`] : '';
}
// 自定义事件key
export const NOTICEONLOAD = 'noticeOnload';
export const NOTICEUNLOAD = 'noticeUnload';
export const NOTICEONCLICK = 'noticeOnclick';

// 组态文件版本号
export const JSON_VERSION = 'V1';
export const NEW_DESIGNER_VERSION = '2.0.0';

export const LANGUAGE_LIST = [
  { key: 'zh-cn', name: '简体中文' },
  { key: 'en-us', name: 'English' }
];
